// extracted by mini-css-extract-plugin
export default {"container":"SearchPopover_container__9cdGS"};